import { KeyValue } from '@/main/models/common';
import { StateFilterRequest } from '@/main/models/request';

export enum StateTypes {
  GET_STATES_USER = '@state/GET_STATES_USER',
  SAVE_STATES_USER = '@state/SAVE_STATES_USER',
  RESET_REDUCER_STATES_USER = '@state/RESET_REDUCER_STATES_USER',
  GET_STATES_BY_BODYSHOP = '@state/GET_STATES_BY_BODYSHOP',
  SAVE_STATES_BY_BODYSHOP = '@state/SAVE_STATES_BY_BODYSHOP',
  RESET_REDUCER_STATES_BY_BODYSHOP = '@state/RESET_REDUCER_STATES_BY_BODYSHOP',
}

export interface StatesState {
  readonly statesUser: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };

  readonly statesUserDomainByBodyshop: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetStatesUser {
  type: typeof StateTypes.GET_STATES_USER;
  payload: {
    request: StateFilterRequest;
  };
}

export interface SaveStatesUser {
  type: typeof StateTypes.SAVE_STATES_USER;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerStatesUser {
  type: typeof StateTypes.RESET_REDUCER_STATES_USER;
}

export interface GetStatesByBodyshop {
  type: typeof StateTypes.GET_STATES_BY_BODYSHOP;
  payload: {
    request: StateFilterRequest;
  };
}

export interface SaveStatesByBodyshop {
  type: typeof StateTypes.SAVE_STATES_BY_BODYSHOP;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerStatesByBodyshop {
  type: typeof StateTypes.RESET_REDUCER_STATES_BY_BODYSHOP;
}

export type StateActionTypes =
  | GetStatesUser
  | SaveStatesUser
  | ResetReducerStatesUser
  | GetStatesByBodyshop
  | SaveStatesByBodyshop
  | ResetReducerStatesByBodyshop;
